<template>
  <section class="carousel">
    <div v-for="(item, i) in items" :key="`item_${i}`">
      <h4 v-if="forMaps && item.cuisine">{{ item.cuisine }}</h4>
      <div class="carousel__top" :class="item.color" v-if="slide === i">
        <h2 v-if="items.length > 1" class="carousel__top--number">
          {{ i + 1 }}
        </h2>
        <img
          class="carousel__top--image"
          :src="require(`../assets/images/${item.image}.png`)"
        />
      </div>
      <div class="carousel__bottom" v-if="slide === i && !forMaps">
        <h4 class="carousel__bottom--title">{{ item.cuisine }}</h4>
        <ul class="carousel__bottom--list">
          <li v-for="(item, i) in item.top" :key="`top_${i}`">
            {{ i + 1 }}. {{ item }}
          </li>
        </ul>
      </div>
    </div>
    <div v-if="items.length > 1" class="carousel__breadcrumbs">
      <img
        v-if="!forMaps"
        class="carousel__breadcrumbs--left"
        src="../assets/images/arrow-left.svg"
        alt="arrow-left"
        @click="slide !== 0 ? (slide -= 1) : (slide = items.length - 1)"
      />
      <div
        class="carousel__breadcrumbs--dots"
        v-for="(item, i) in items"
        :key="`crumb_${i}`"
        alt="arrow-right"
        @click="slide = i"
      >
        <img
          :style="slide === i && 'transform: scale(1.5);'"
          src="../assets/images/dot.svg"
          alt="dot"
        />
      </div>
      <img
        v-if="!forMaps"
        class="carousel__breadcrumbs--right"
        src="../assets/images/arrow-right.svg"
        alt="arrow-right"
        @click="slide !== items.length - 1 ? (slide += 1) : (slide = 0)"
      />
    </div>
    <div v-for="(item, i) in items" :key="`list_${i}`">
      <div class="carousel__map-bottom" v-if="slide === i && forMaps">
        <h4 class="carousel__map-bottom--title" v-if="item.top_title">
          {{ item.top_title }}
        </h4>
        <ul class="carousel__map-bottom--list">
          <li v-for="(item, i) in item.top" :key="`top_${i}`">
            <p>
              <span>{{ i + 1 }}.</span> {{ item }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FoodCarousel',
  props: {
    items: {
      type: Array,
      default: () => [],
      required: true,
    },
    forMaps: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      slide: 0,
    }
  },
}
</script>

<style lang="scss">
$desktop: 1044px;
$tablet: 768px;
$mobile: 600px;

.carousel {
  width: 100%;
  &__top {
    display: flex;
    border-radius: 30px;
    justify-content: space-between;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: flex-start;
    align-items: center;
    height: 350px;
    margin-top: 70px;
    @media (max-width: $tablet) {
      flex-direction: column;
      align-items: flex-start;
      height: auto;
    }
    &--number {
      padding: 15px 30px 0;
      margin: 15px 0 0;
    }
    &--image {
      width: 100%;
      @media (max-width: $tablet) {
        width: 100%;
      }
    }
  }
  &__bottom {
    background-color: var(--color-grey-1);
    border-radius: 30px;
    padding: 15px 30px;
    margin: 40px 0 0;
    @media (max-width: $tablet) {
      margin-bottom: 50px;
    }
    &--title {
      margin: 10px 0;
    }
    &--list {
      list-style: none;
      margin: 10px;
      padding: 0;
      display: flex;
      flex-direction: column;
      li {
        margin: 10px 0;
      }
    }
  }
  &__map-bottom {
    @media (max-width: $tablet) {
      padding: 0;
    }
    &--title {
      @media (max-width: $tablet) {
        margin: 20px 0 0;
      }
    }
    &--list {
      list-style: none;
      margin: 10px;
      padding: 0;
      li {
        p {
          span {
            color: var(--color-orange-1);
            font-weight: 600;
            font-size: 20px;
            margin-right: 10px;
          }
        }
      }
    }
  }
  &__breadcrumbs {
    display: flex;
    text-align: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 20px;
    align-items: flex-end;
    &--left {
      margin-right: 10px;
    }
    &--dots {
      margin: 0 10px;
    }
    &--right {
      margin-left: 10px;
    }
  }
}
.cupcake {
  background-color: var(--color-cupcake-1);
  color: var(--color-charcoal-1);
}
.tomato {
  background-color: var(--color-tomato-1);
  color: var(--color-charcoal-1);
}
.orange {
  background-color: var(--color-orange-1);
  color: var(--color-white-1);
}
.berry {
  background-color: var(--color-berry-1);
  color: var(--color-charcoal-1);
}
.tumeric {
  background-color: var(--color-tumeric-1);
  color: var(--color-charcoal-1);
}
.aubergine {
  background-color: var(--color-aubergine-1);
  color: var(--color-white-1);
}
</style>